// import "./src/styles/inter_font.css";
import "./src/styles/global.css";
import "./src/styles/fonts.css";
import "./src/styles/articles.css";
import "./src/styles/slider.css";
import "./src/styles/services.css";
import "./src/styles/case-studies.css";
import "./src/styles/breadcrumb.css";
import "./src/styles/industries.css";
import "./src/styles/locations.css";
import "./src/styles/qnas.css";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import {
  applyH1TitleFallback,
  observeHeadForTitleFallback,
} from "./src/lib/h1TitleFallback";

export { wrapPageElement } from "./src/components/CookieConsentProvider";

export const onClientEntry = () => {
  observeHeadForTitleFallback();
};

export const onRouteUpdate = () => {
  applyH1TitleFallback();
};
